import React, { useState, useEffect, useRef, FormEvent } from 'react';
import styles from './FieldModal.scss';
import useUser, { IUserState } from '../../stores/useUser';
// import JsonApiRequest, { IUser } from '../../utils/JsonApiRequest';
import Error from '../Error';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// @ts-ignore
import turndownService from 'turndown';
import Markdown from '../Markdown';
import { IUserPassword, IHtmlInput } from '../../utils/JsonApiRequest';
import TextField from '../MaterialUi/TextField';
import DialogTrigger from '../MaterialUi/DialogTrigger';
import { createToast } from '../MaterialUi/Toast';
import EditIcon from '@mui/icons-material/Edit';
import LogError from '../../utils/LogError';
import JoditEditor, { Jodit } from 'jodit-react';
import JsonApiError from '../JsonApiError';
import Button from '../MaterialUi/Button';

const turndown = new turndownService();

export const joditEditorConfig = {
    buttons: ['paragraph', '|', 'bold', 'italic', '|', 'link', '|', 'ul', 'ol', '|', 'source'],
    toolbarAdaptive: false,
    link: {
        noFollowCheckbox: false,
        openInNewTabCheckbox: false,
        modeClassName: false
    },
    controls: {

        ul: {
            list: undefined
        },
        ol: {
            list: undefined
        },
        paragraph: {
            list: Jodit.atom({
                h2: 'Überschrift groß',
                h3: 'Überschrift klein',
                p: 'Absatz'
            })
        }

    },
    askBeforePasteFromWord: false,
    askBeforePasteHTML: false,
    nl2brInPlainText: true,
    defaultActionOnPaste: "insert_clear_html" as const,
    cleanHTML: {
        cleanOnPaste: true,
        safeJavaScriptLink: false,
        fillEmptyParagraph: false,
        removeEmptyElements: true,
        replaceNBSP: true,
        replaceEmptyTags: true,
        allowTags: {
            h2: true,
            h3: true,
            em: true,
            a: {
                href: true
            },
            ul: true,
            ol: true,
            li: true,
            p: true,
            span: true,
            strong: true,
            br: true,
            div: true,
            hr: true,
            sub: true,
            sup: true,
        },
        "replaceOldTags": {
            h1: 'h2',
            h4: 'h3',
            h5: 'h3',
            h6: 'h3',
            i: 'em',
            b: 'strong',
            table: 'div',
            tr: 'div',
            td: 'div',
            th: 'div',
            tbody: 'div',
            thead: 'div',
            tfoot: 'div',
            caption: 'div',
            col: 'div',
            colgroup: 'div',
            u: 'span',
            s: 'span',
            strike: 'span',
            font: 'span',
            center: 'div',
            big: 'span',
            small: 'span',
            address: 'div',
            blockquote: 'div',
            q: 'div',
            code: 'div',
            pre: 'div',
            tt: 'span',
            samp: 'span',
            kbd: 'span',
            var: 'span',
            cite: 'span',
            abbr: 'span',
            acronym: 'span',
            section: 'div',
        },
    }
}

export interface IFieldModalProps {
    name: string;
    /**
     * description text or markdown
     */
    annotation?: string;
    label: string;
    type?: 'text' | 'url' | 'email' | 'html';
    value: string | IUserPassword;
    required?: boolean;
    onSubmit: (name: string, value: string | IUserPassword | IHtmlInput) => Promise<any>;
    hasChildOverlayThatNeedsFocus?: boolean; // disable material focus trap (disableEnforceFocus=true)
}

const FieldModal: React.FC<React.PropsWithChildren<IFieldModalProps>> = ({
    name,
    value,
    label,
    type = 'text',
    required = false,
    annotation = null,
    onSubmit = null,
    hasChildOverlayThatNeedsFocus: hasChildOverlays,
}) => {
    const [edit, setEdit] = useState<boolean>(false);
    // const [pUser, userActions] = useUser();

    const [user] = useUser();

    // const editor = useRef(null);


    const [nextValue, setNextValue] = useState<string | IUserPassword>(value);
    const [value2, setValue2] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [errors, setErrors] = useState<Array<{ title: string; detail: string }>>(null);

    const modalRef = useRef();

    useEffect(() => {
        setErrors([]);
    }, [edit]);

    useEffect(() => {
        setNextValue(value);
    }, [value]);

    const handleChange = (name: IFieldModalProps['name'], ev: React.FormEvent) => {
        const value = (ev.target as HTMLInputElement).value;
        setNextValue(value);

        setIsButtonDisabled(false);
    };
    // const handleEditorChange = (eventInfo, batch) => {
    //     // console.log(eventInfo, batch);
    //     console.debug('handleEditorChange', batch.getData());
    //     const val = batch.getData();
    //     setNextValue(val);
    // };
    const handleEditorChange = (value) => {
        // console.log(eventInfo, batch);
        console.debug('handleEditorChange', value);
        // const val = batch.getData();
        setNextValue(value);
    };
    const handlePass2Change = (name: IFieldModalProps['name'], ev: React.FormEvent) => {
        const nextValue2 = (ev.target as HTMLInputElement).value;
        if (nextValue2 !== nextValue) {
            setIsButtonDisabled(true);
        } else {
            setIsButtonDisabled(false);
        }
        setValue2(nextValue2);
        // setNextUser({ ...nextUser });
    };

    const handleCancel = () => {
        setNextValue(value);
        // setEdit(false);
        setTimeout(() => {
            setEdit(false);
        }, 0);
    };

    const handleSave = (ev: React.FormEvent) => {
        ev.preventDefault();

        setIsLoading(true);
        if (onSubmit) {
            onSubmit(name, nextValue)
                .then(() => {
                    setIsLoading(false);
                    setEdit(false);
                    createToast('Die Änderungen wurden gespeichert.', 'success');
                })
                .catch((e) => {
                    setErrors(e?.responseData?.errors);
                    setIsLoading(false);
                    createToast(<JsonApiError error={e} text="Fehler beim Speichern!" />, 'error');
                    LogError.add(e, {
                        title: 'Fehler beim Speichern des Profil-Feldes',
                        error_code: 'FieldModal.tsx:handleSave',
                        request_data: { name, nextValue },
                    });
                });
        } else {
            console.error('onSubmit is not a function');
        }
    };

    let previewValue = <span>{typeof value === 'string' ? value : ''}</span>;
    switch (type) {
        case 'html':
            previewValue = <Markdown linkTarget="_blank" variant='legal'>{turndown.turndown(value || '')}</Markdown>;
            break;
    }

    return (
        <div
            className={styles.fieldModal}
        // onClick={() => {
        //     setEdit(true);
        // }}
        >
            <DialogTrigger
                // ref={modalRef}
                title={label}
                open={edit}
                onSubmit={handleSave}
                onClick={() => {
                    setEdit(true);
                }}
                disableEnforceFocus={hasChildOverlays}
                onClose={() => {
                    setEdit(false);
                }}
                // maxWidth="93.75vw"
                trigger={
                    <>
                        <span className={styles.label}>{label}</span>
                        <span className={styles.value + ' ' + styles[type]}>{previewValue}</span>
                        <span className={styles.edit}>
                            <EditIcon />
                        </span>
                    </>
                }
                // options={{
                //     onCloseStart: () => {
                //         setEdit(false);
                //     },
                //     endingTop: '2%',
                // }}
                actions={[
                    <Button disabled={isButtonDisabled} loading={isLoading} type="submit">
                        Speichern
                    </Button>,
                ]}
                className={styles.modal}
            >
                {/* <form onSubmit={handleSave}> */}
                {['text', 'url', 'email'].find((i) => i === type) && (
                    <TextField
                        name={name}
                        value={nextValue || (type === 'url' ? 'https://' : '')}
                        onChange={(ev) => {
                            handleChange(name, ev);
                        }}
                        label={label}
                        required={required}
                        type={type}
                    />
                )}
                {type === 'html' && (
                    <>
                        {/* <h5>{label}</h5> */}
                        {/* <CKEditor
                            editor={ClassicEditor}
                            data={typeof nextValue === 'string' ? nextValue : ''}
                            onChange={handleEditorChange}
                            config={
                                // user.isAdmin
                                //     ? { contentsCss: '/themes/custom/dnz_emulsify/dist/style.css' }
                                //     :
                                {
                                    toolbar: ['Bold', 'Italic', '|', 'Link', '|', 'BulletedList', 'NumberedList', '|', 'Source'],
                                    // contentsCss: '/themes/custom/dnz_emulsify/dist/style.css',
                                }
                            }
                        /> */}
                        <div className='App__app___dnz'>
                            <JoditEditor
                                // ref={editor}
                                className='Markdown__markdown___dnz Markdown__legal___dnz'
                                value={typeof nextValue === 'string' ? nextValue : ''}
                                config={joditEditorConfig}
                                // tabIndex={1} // tabIndex of textarea
                                onBlur={handleEditorChange} // preferred to use only this option to update the content for performance reasons
                                onChange={newContent => { }}

                            />
                        </div>
                    </>
                )}
                <div>
                    {errors?.map((e, idx) => (
                        <Error key={idx}>
                            {e.title} {e.detail}
                        </Error>
                    ))}
                </div>
                <Markdown className={styles.annotation} variant='legal'>{annotation}</Markdown>

                {/* </form> */}
            </DialogTrigger>
        </div>
    );
};

export default FieldModal;
